import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useAutoLogout = (timeout = 1800000) => { // Default: 30 minutes (30 * 60 * 1000 ms)
    const navigate = useNavigate();

    const logout = useCallback(() => {
        // Clear session storage
        sessionStorage.clear();
        // Redirect to login page
        navigate('/');
        // Optional: Reload to clear state completely
        window.location.reload();
    }, [navigate]);

    useEffect(() => {
        // Only active if user is logged in
        const role = sessionStorage.getItem('userRole');
        const aid = sessionStorage.getItem('akademisyen_id');

        if (!role && !aid) return;

        let timer;

        const resetTimer = () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(logout, timeout);
        };

        // Events to listen for activity
        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

        // Add event listeners
        events.forEach(event => {
            window.addEventListener(event, resetTimer);
        });

        // Initialize timer
        resetTimer();

        // Cleanup
        return () => {
            if (timer) clearTimeout(timer);
            events.forEach(event => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [logout, timeout]);

    return logout;
};

export default useAutoLogout;
